export default "__VITE_ASSET__LbT4VbHx__"